import { render, staticRenderFns } from "./Invitation.vue?vue&type=template&id=8504efa2"
import script from "./Invitation.vue?vue&type=script&lang=js"
export * from "./Invitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports